export default {
    INTEGER: 'INTEGER',
    DECIMAL: 'DECIMAL',
    PERCENT: 'PERCENT',
    TEXT: 'TEXT',
    DATE: 'DATE',
    MONEY: 'MONEY'
};
